import { render, staticRenderFns } from "./GoodsReceiving.vue?vue&type=template&id=4b71c6e4&"
import script from "./GoodsReceiving.vue?vue&type=script&lang=js&"
export * from "./GoodsReceiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports